import { Injectable } from '@angular/core';
import {
    SnapshotImageContract,
    SnapshotMapType,
} from '@polaris-customerweb/sharedcomponents.core';
import { toLower } from 'lodash-es';
import { Observable } from 'rxjs';
import { SnapshotResourceService } from './snapshot-resource.service';

@Injectable({
    providedIn: 'root',
})
export class SnapshotService {
    constructor(private snapshotResourceService: SnapshotResourceService) {}

    getSnapshot(
        mapObject:
            | GeoJSON.Feature<
                  GeoJSON.Point | GeoJSON.Polygon | GeoJSON.LineString
              >
            | GeoJSON.FeatureCollection<GeoJSON.LineString | GeoJSON.Point>,
        mapId: string,
        width: number,
        height: number,
        style: 'plannedRide' | 'trackedRide' = 'plannedRide'
    ): Observable<SnapshotImageContract> {
        return this.snapshotResourceService.getSnapshot(
            mapObject,
            mapId,
            width,
            height,
            style
        );
    }

    getSnapshotUrl(
        snapshots: readonly SnapshotImageContract[],
        sizes: string[],
        mapType?: SnapshotMapType
    ): string {
        let snapshotOfMapType: SnapshotImageContract | undefined;
        let snapshotRegardlessOfMapType: SnapshotImageContract | undefined;

        for (const size of sizes) {
            if (mapType) {
                snapshotOfMapType = snapshots.find(
                    (snapshot) =>
                        toLower(snapshot.size) === toLower(size) &&
                        snapshot.mapType === mapType
                );

                if (snapshotOfMapType) {
                    break;
                }
            }

            // Get snapshot for this size regardless of map type even if map type
            // is set, in case there is no snapshot matching desired map type.
            snapshotRegardlessOfMapType = snapshots.find(
                (snapshot) => toLower(snapshot.size) === toLower(size)
            );

            if (!mapType && snapshotRegardlessOfMapType) {
                break;
            }
        }

        const foundSnapshot = snapshotOfMapType || snapshotRegardlessOfMapType;
        return foundSnapshot?.url || '';
    }
}
